import { Trans } from 'react-i18next';
import { Button, Flex, Heading } from '@chakra-ui/react';

const StartAnother = () => {
  const handleStartAnother = () => {
    window.localStorage.removeItem('persist:root');
  };

  return (
    <Flex direction="column" align="center" gap={2}>
      <Heading size="md">
        <Trans>Want to start a new estimate?</Trans>
      </Heading>
      <form onSubmit={handleStartAnother} action="/">
        <Button size="sm" type="submit" variant="link">
          <Trans>Start again</Trans>
        </Button>
      </form>
    </Flex>
  );
};

export default StartAnother;
